import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsListService } from '../forms-list/forms-list.service';
import * as _ from 'lodash';
@Component({
  selector: 'app-create-folder',
  templateUrl: './create-folder.component.html',
  styleUrls: ['./create-folder.component.scss']
})
export class CreateFolderComponent implements OnInit {
  folderName: any;
  folder: any;
  type: any;
  searchText:string;
  formsList;
  formList:any;
  templates;
  selectedTemplateList = [];
  constructor(
    public activeModal: NgbActiveModal,
    private _formsListService: FormsListService
    ) {}
  close() {
    this.activeModal.dismiss();
  }
  ngOnInit() {
    if (this.type !== 'addFolder') {
    this.onScroll();
    }
  }
  getFirstLetterString(name) {
    let result = '';
    let splitArray = name.split(' ');
    if (name.length === 1) {
      result = name;
    } else if (splitArray.length === 1) {
      result = splitArray[0][0] + splitArray[0][1];
    } else {
      _.forEach(splitArray, function(word) {
        result = result.concat(word[0]);
      });
    }

    return result.substring(0, 2);
  }
  createFolder() {
    if (this.type === 'addFolder') {
      this.folder(this.folderName);
      this.activeModal.dismiss();
    } else {
      if(this.selectedTemplateList.length > 0){
      this.formList(this.selectedTemplateList);
      this.activeModal.dismiss();
    }
  }
  }
  onChange(selectTemplate, $event,i){
    if($event.checked){
      this.selectedTemplateList.push(selectTemplate);
    }else{
      const index = this.selectedTemplateList.indexOf(selectTemplate);
      if (index !== -1) {
          this.selectedTemplateList.splice(index, 1);
      }
    }
  }
  onScroll() {
          this.formsList = this.templates;
  }
  getNewFormList(value){
    this.formsList = this.templates.filter(item => item.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }
}



// WEBPACK FOOTER //
// ./src/app/create-folder/create-folder.component.ts